// 17 SEO service pages — data-driven, rendered by pages/ServiceDetail.jsx
export const SERVICE_PAGES = [
  {
    slug: "check-engine-light-diagnostics",
    name: "Check-Engine-Light Diagnostics",
    icon: "Cpu",
    cardNames: ["Engine Diagnostics"],
    seoTitle: "Mobile Check Engine Light Diagnostics Las Vegas | Mason's Mobile",
    metaDesc: "Check engine light on? Mason's Mobile performs mobile car diagnostics at your home or work in Las Vegas, Henderson and nearby areas. Honest answers, upfront pricing.",
    h1: "Mobile Check-Engine-Light Diagnostics in Las Vegas",
    local: "Searching for mobile car diagnostics in Las Vegas or Henderson? We bring professional scan tools to your driveway.",
    desc: [
      "A check engine light can mean anything from a loose gas cap to a failing sensor. Instead of driving to a shop and waiting, Mason's Mobile comes to you with professional-grade diagnostic equipment, reads the codes, tests the affected systems, and explains exactly what's wrong in plain language.",
      "You get a clear diagnosis and an honest quote before any repair begins — often for less than dealerships charge just to look at the car.",
    ],
    signs: ["Check engine light on or flashing", "Reduced power or rough running", "Failed emissions/smog test", "Poor fuel economy", "Warning lights after refueling"],
  },
  {
    slug: "no-start-troubleshooting",
    name: "No-Start & Vehicle Troubleshooting",
    icon: "Power",
    cardNames: [],
    seoTitle: "Car Won't Start? Mobile Mechanic Las Vegas | Mason's Mobile",
    metaDesc: "Car won't start in Las Vegas, Henderson or Spring Valley? Mason's Mobile diagnoses no-start problems where your car sits — battery, starter, alternator, fuel or ignition.",
    h1: "Car Won't Start? We Come to You",
    local: "A no-start car can't drive to a shop — that's exactly what a mobile mechanic near you is for.",
    desc: [
      "When your car won't crank or cranks but won't fire, Mason's Mobile troubleshoots the cause on the spot: battery, starter, alternator, fuel delivery, ignition, or security system. No towing bill, no guesswork.",
      "Most no-start problems are diagnosed within the first visit and many are fixed the same day, right where the vehicle sits — at home, at work, or in a parking lot anywhere in the Las Vegas Valley.",
    ],
    signs: ["Engine cranks but won't start", "Single click or no sound when turning the key", "Intermittent starting problems", "Stalling after starting", "Dashboard lights but no crank"],
  },
  {
    slug: "battery-testing-replacement",
    name: "Battery Testing & Replacement",
    icon: "BatteryCharging",
    cardNames: ["Battery Replacement"],
    seoTitle: "Mobile Battery Replacement Las Vegas | Mason's Mobile Mechanic",
    metaDesc: "Dead battery? Mason's Mobile tests and replaces car batteries on the spot across Las Vegas, Henderson and Enterprise. We come to your home, office or parking lot.",
    h1: "Mobile Battery Testing & Replacement",
    local: "Vegas heat kills batteries faster than almost anywhere in the country — we test and replace them at your location.",
    desc: [
      "Mason's Mobile load-tests your battery and charging system, and if the battery is done, we install a quality replacement on the spot. No jump-starting your way to a parts store.",
      "We also check the alternator and connections while we're there, so you don't replace a good battery when the real problem is the charging system.",
    ],
    signs: ["Slow cranking, especially on hot days", "Battery warning light", "Corroded terminals", "Battery over 3-4 years old", "Needed a jump-start recently"],
  },
  {
    slug: "starter-alternator-replacement",
    name: "Starter & Alternator Replacement",
    icon: "Zap",
    cardNames: ["Starter Replacement", "Alternator Repair"],
    seoTitle: "Mobile Starter & Alternator Replacement Las Vegas | Mason's Mobile",
    metaDesc: "Starter or alternator failing? Mason's Mobile replaces starters and alternators at your location in Las Vegas, Henderson and the surrounding valley. Upfront quotes.",
    h1: "Starter & Alternator Replacement at Your Location",
    local: "Affordable auto repair in Las Vegas starts with skipping the tow truck — we replace starters and alternators where the car sits.",
    desc: [
      "A failed starter or alternator usually leaves the car stranded — which makes mobile repair the obvious answer. Mason's Mobile tests the charging and starting system, confirms the failed part, and replaces it on-site with quality components.",
      "Most starter and alternator jobs are completed in a single visit, and you'll get a reliable quote over the phone before we head your way.",
    ],
    signs: ["Clicking when turning the key", "Battery light on while driving", "Dimming headlights", "Whining noise from the engine", "Repeated dead batteries"],
  },
  {
    slug: "brake-repair",
    name: "Brake Pads, Rotors & Brake Repair",
    icon: "Disc3",
    cardNames: ["Brake Pads & Rotors"],
    seoTitle: "Mobile Brake Repair Las Vegas | Brake Pads & Rotors — Mason's Mobile",
    metaDesc: "Mobile brake repair in Las Vegas and Henderson: brake pads, rotors and calipers replaced in your driveway. Safety-first service at prices below the big shops.",
    h1: "Mobile Brake Repair — Pads, Rotors & More",
    local: "Looking for mobile brake repair in Las Vegas? We complete most brake jobs in your driveway the same day.",
    desc: [
      "Brakes are the one repair you should never put off. Mason's Mobile replaces pads, rotors, and calipers at your home or workplace using quality parts, then road-tests the vehicle to confirm everything is right.",
      "Because we don't carry big-shop overhead, our brake service typically costs meaningfully less than dealerships and chain stores — without cutting corners on safety.",
    ],
    signs: ["Squealing or grinding when braking", "Vibration in the pedal or wheel", "Longer stopping distances", "Brake warning light", "Car pulls to one side when braking"],
  },
  {
    slug: "oil-change-maintenance",
    name: "Oil Changes & Routine Maintenance",
    icon: "Droplets",
    cardNames: ["Oil Change Service", "Tune-Ups & Maintenance"],
    seoTitle: "Mobile Oil Change Las Vegas | Routine Maintenance — Mason's Mobile",
    metaDesc: "Full-synthetic mobile oil changes and factory-scheduled maintenance at your home or office in Las Vegas, Henderson, Spring Valley and Enterprise.",
    h1: "Mobile Oil Changes & Routine Maintenance",
    local: "Skip the waiting room — we handle oil changes and scheduled maintenance wherever your car is parked.",
    desc: [
      "Mason's Mobile performs full-synthetic and conventional oil changes, filter replacements, fluid top-offs, and factory-scheduled maintenance in your driveway while you get on with your day.",
      "Regular maintenance is the cheapest insurance against Vegas heat — and members save even more with our maintenance membership.",
    ],
    signs: ["Oil change reminder or sticker overdue", "Dark or gritty oil on the dipstick", "Oil pressure warning light", "Engine running louder than usual", "Approaching a service milestone"],
  },
  {
    slug: "tune-ups-spark-plugs",
    name: "Tune-Ups & Spark-Plug Replacement",
    icon: "Flame",
    cardNames: ["Spark Plugs & Coils"],
    seoTitle: "Mobile Tune-Up & Spark Plug Replacement Las Vegas | Mason's Mobile",
    metaDesc: "Rough idle or misfires? Mason's Mobile performs tune-ups and spark-plug replacement at your location across the Las Vegas Valley. Honest, upfront pricing.",
    h1: "Mobile Tune-Ups & Spark-Plug Replacement",
    local: "A proper tune-up restores power and fuel economy — done at your home anywhere in the Las Vegas Valley.",
    desc: [
      "Worn spark plugs cause misfires, rough idle, and wasted fuel. Mason's Mobile replaces plugs, inspects coils and wires, and performs complete tune-ups on-site — restoring smooth running without a shop visit.",
      "We'll tell you exactly which parts actually need replacing, and which don't. No padded service lists.",
    ],
    signs: ["Rough idle or shaking", "Misfires or hesitation under acceleration", "Hard starting", "Drop in fuel economy", "100k+ miles on original plugs"],
  },
  {
    slug: "ignition-coils-sensors",
    name: "Ignition Coils & Sensors",
    icon: "Gauge",
    cardNames: [],
    seoTitle: "Ignition Coil & Sensor Replacement Las Vegas | Mason's Mobile",
    metaDesc: "Misfire codes, O2 sensors, cam and crank sensors — Mason's Mobile diagnoses and replaces ignition coils and engine sensors at your location in Las Vegas and Henderson.",
    h1: "Ignition Coils & Engine Sensor Replacement",
    local: "From misfire codes to failed O2 sensors — diagnosed and replaced at your home or workplace.",
    desc: [
      "Modern engines rely on dozens of sensors and individual ignition coils. When one fails, you get warning lights, misfires, or poor running. Mason's Mobile pinpoints the exact failed component with professional diagnostics — no parts-cannon guessing.",
      "We replace ignition coils, oxygen sensors, camshaft and crankshaft sensors, MAF sensors and more, on-site and warrantied.",
    ],
    signs: ["Misfire codes (P0300 series)", "Flashing check engine light", "Poor acceleration", "Failed smog check", "Rough running in the morning"],
  },
  {
    slug: "cooling-system-repair",
    name: "Radiators, Thermostats & Cooling",
    icon: "Thermometer",
    cardNames: ["Radiator & Cooling"],
    seoTitle: "Mobile Radiator & Cooling System Repair Las Vegas | Mason's Mobile",
    metaDesc: "Overheating in Vegas heat? Mason's Mobile repairs radiators, thermostats and cooling systems at your location across Las Vegas, Henderson and Enterprise.",
    h1: "Radiator, Thermostat & Cooling-System Repair",
    local: "Overheating is the #1 breakdown in the desert — we fix cooling systems before (and after) they leave you stranded.",
    desc: [
      "Las Vegas summers are merciless on cooling systems. Mason's Mobile pressure-tests for leaks and replaces radiators, thermostats, hoses, and coolant on-site, so your engine survives the heat.",
      "Caught early, a cooling repair costs a fraction of the engine damage overheating causes. If your temp gauge is creeping, call before it strands you.",
    ],
    signs: ["Temperature gauge running high", "Coolant puddles under the car", "Sweet smell from the engine bay", "Steam from under the hood", "Heater blowing cold"],
  },
  {
    slug: "belts-hoses-water-pumps",
    name: "Belts, Hoses & Water Pumps",
    icon: "RefreshCw",
    cardNames: ["Serpentine Belts", "Water Pump Replacement"],
    seoTitle: "Serpentine Belt, Hose & Water Pump Replacement Las Vegas | Mason's Mobile",
    metaDesc: "Cracked belts, leaking hoses, failing water pumps — replaced at your Las Vegas home or workplace by Mason's Mobile before they leave you stranded.",
    h1: "Belts, Hoses & Water-Pump Replacement",
    local: "A $60 belt shouldn't turn into a $6,000 engine. We replace belts, hoses and water pumps on-site.",
    desc: [
      "Rubber components age fast in desert heat. Mason's Mobile inspects and replaces serpentine belts, coolant hoses, and water pumps at your location — the small repairs that prevent catastrophic breakdowns.",
      "We'll show you the worn part and explain the condition honestly. If it has life left, we'll tell you that too.",
    ],
    signs: ["Squealing on startup", "Visible cracks in the belt", "Coolant leak near the front of the engine", "Whining or grinding from the pump", "Overheating at idle"],
  },
  {
    slug: "suspension-steering-repair",
    name: "Suspension & Steering Repairs",
    icon: "MoveVertical",
    cardNames: ["Suspension & Struts", "Power Steering", "Wheel Bearings", "CV Axle Replacement"],
    seoTitle: "Mobile Suspension & Steering Repair Las Vegas | Mason's Mobile",
    metaDesc: "Clunks, wandering steering, uneven tire wear — Mason's Mobile repairs suspension and steering at your location in Las Vegas, Henderson and Spring Valley.",
    h1: "Suspension & Steering Repair at Your Location",
    local: "If the ride feels wrong, it probably is. We diagnose suspension and steering problems in your driveway.",
    desc: [
      "Worn suspension doesn't just ride rough — it eats tires and stretches stopping distances. Mason's Mobile inspects and repairs control arms, tie rods, ball joints, wheel bearings, CV axles and power steering components on-site.",
      "Larger suspension jobs that need a lift can be arranged at our trusted local garage, keeping the same honest pricing and personal service.",
    ],
    signs: ["Clunking over bumps", "Wandering or loose steering", "Uneven or cupped tire wear", "Nose-diving when braking", "Humming that changes with speed"],
  },
  {
    slug: "shocks-struts-control-arms",
    name: "Shocks, Struts & Control Arms",
    icon: "LifeBuoy",
    cardNames: [],
    seoTitle: "Shock, Strut & Control Arm Replacement Las Vegas | Mason's Mobile",
    metaDesc: "Bouncy ride or clunking front end? Mason's Mobile replaces shocks, struts and control arms for Las Vegas and Henderson drivers — at your home or our partner garage.",
    h1: "Shocks, Struts & Control-Arm Replacement",
    local: "Restore a safe, controlled ride — replaced at your home or arranged at our trusted local garage for bigger jobs.",
    desc: [
      "Shocks and struts are wear items: after 50-80k Vegas miles they stop controlling the ride, and worn control arm bushings add clunks and vague steering. Mason's Mobile replaces them with quality parts and checks the rest of the suspension while we're in there.",
      "Some strut jobs need spring compressors and a lift — for those we arrange service at our trusted local garage, so you still get mobile-mechanic pricing and personal service.",
    ],
    signs: ["Bouncing after bumps", "Clunking from the front end", "Fluid leaking from a shock", "Cupped tire wear", "Excessive body roll in corners"],
  },
  {
    slug: "fuel-system-repair",
    name: "Fuel Pumps & Fuel-System Repairs",
    icon: "Fuel",
    cardNames: ["Fuel System Repair"],
    seoTitle: "Fuel Pump & Fuel System Repair Las Vegas | Mason's Mobile Mechanic",
    metaDesc: "Fuel pump failure, clogged injectors, fuel filters — Mason's Mobile repairs fuel systems at your Las Vegas or Henderson location. Reliable quotes over the phone.",
    h1: "Fuel Pump & Fuel-System Repair",
    local: "A failed fuel pump strands the car — perfect work for a mobile mechanic near you.",
    desc: [
      "No fuel, no start. Mason's Mobile tests fuel pressure and delivery, then replaces fuel pumps, filters, and injectors on-site, restoring reliable fuel supply without a tow.",
      "We verify the actual failure before replacing anything — fuel-system symptoms are often confused with ignition or sensor problems, and we won't sell you a pump you don't need.",
    ],
    signs: ["Engine cranks but won't fire", "Sputtering at high speed", "Whining from the fuel tank", "Loss of power under load", "Hard starts when hot"],
  },
  {
    slug: "electrical-diagnostics",
    name: "Electrical Diagnostics",
    icon: "PlugZap",
    cardNames: ["Electrical Diagnostics"],
    seoTitle: "Mobile Auto Electrical Diagnostics Las Vegas | Mason's Mobile",
    metaDesc: "Battery drains, blown fuses, dead windows, wiring gremlins — Mason's Mobile tracks down automotive electrical problems at your Las Vegas Valley location.",
    h1: "Automotive Electrical Diagnostics",
    local: "Electrical gremlins are the hardest problems to chase — we bring the test equipment to your driveway.",
    desc: [
      "Parasitic battery drains, intermittent no-starts, dead accessories, blown fuses — electrical faults frustrate drivers and shops alike. Mason's Mobile methodically tests circuits, grounds, relays and modules at your location to find the real cause.",
      "You pay for skilled diagnosis, not hours of shop guesswork, and we explain exactly what we found before quoting the fix.",
    ],
    signs: ["Battery dead every morning", "Fuses that keep blowing", "Flickering lights or gauges", "Windows/locks stopped working", "Intermittent warning lights"],
  },
  {
    slug: "pre-purchase-inspection",
    name: "Pre-Purchase Vehicle Inspections",
    icon: "SearchCheck",
    cardNames: ["Pre-Purchase Inspections"],
    seoTitle: "Pre-Purchase Car Inspection Las Vegas | Mason's Mobile Mechanic",
    metaDesc: "Buying a used car in Las Vegas or Henderson? Mason's Mobile inspects it at the seller's location before you commit — engine, brakes, suspension, leaks and codes.",
    h1: "Pre-Purchase Vehicle Inspections",
    local: "We meet you (or the seller) anywhere in the Las Vegas Valley and inspect the car before money changes hands.",
    desc: [
      "A used car can hide thousands of dollars in problems behind a wash and wax. Mason's Mobile inspects the engine, transmission, brakes, suspension, tires, fluids and computer codes at the seller's location, then gives you a straight verdict.",
      "One inspection routinely saves buyers far more than it costs — and gives you real negotiating power on price.",
    ],
    signs: ["Buying from a private seller", "Out-of-state or auction vehicle", "No service records available", "Deal feels too good", "Dealer won't allow an independent shop visit — we come to the lot"],
  },
  {
    slug: "fleet-maintenance",
    name: "Fleet & Commercial Vehicle Service",
    icon: "Truck",
    cardNames: ["Fleet & Commercial Service"],
    seoTitle: "Mobile Fleet Maintenance Las Vegas | Commercial Vehicle Service — Mason's Mobile",
    metaDesc: "Keep work trucks and vans on the road. Mason's Mobile provides on-site fleet maintenance and commercial vehicle service across Las Vegas, Henderson and Enterprise.",
    h1: "Fleet Maintenance & Commercial Vehicle Service",
    local: "Every hour a work vehicle sits in a shop costs you money — we service fleets on-site, on your schedule.",
    desc: [
      "Mason's Mobile services work trucks, vans, and small fleets at your yard or job site: oil changes, brakes, batteries, diagnostics, and scheduled maintenance handled around your operating hours.",
      "Consistent on-site maintenance means fewer surprise breakdowns, less downtime, and one trusted mechanic who knows your vehicles. Call for fleet scheduling and volume arrangements.",
    ],
    signs: ["Vehicles overdue for scheduled service", "Breakdowns disrupting jobs", "No time to shuttle trucks to a shop", "Mixed fleet with scattered records", "Drivers reporting warning lights"],
  },
  {
    slug: "emergency-mobile-mechanic",
    name: "Emergency & Same-Day Service",
    icon: "Siren",
    cardNames: ["Emergency Roadside"],
    seoTitle: "Emergency Mobile Mechanic Las Vegas | Same-Day Service — Mason's Mobile",
    metaDesc: "Broken down in Las Vegas? Mason's Mobile offers emergency and same-day mobile mechanic service when available — no-starts, breakdowns and roadside repairs.",
    h1: "Emergency & Same-Day Mobile Mechanic Service",
    local: "Stranded in the valley? Call first — many breakdowns can be fixed on the spot, skipping the tow entirely.",
    desc: [
      "Breakdowns don't wait for appointments. When availability allows, Mason's Mobile provides same-day and emergency service for no-starts, dead batteries, overheating and roadside breakdowns across the Las Vegas Valley.",
      "Many 'call a tow truck' situations are actually a battery, belt, or sensor that we can fix on the spot for less than the tow would cost.",
    ],
    signs: ["Car died and won't restart", "Broken down at work or a store", "Overheated on the road", "Battery dead in a parking garage", "Need a repair completed today"],
  },
];

export const findServicePage = (slug) => SERVICE_PAGES.find((p) => p.slug === slug);

export const slugForServiceName = (name) => {
  const page = SERVICE_PAGES.find((p) => p.cardNames.includes(name) || p.name === name);
  return page ? page.slug : null;
};
